import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';

import createShipmentActions from './CreateShipment/actions.createShipment';
import createShipmentMutations from './CreateShipment/mutations.createShipment';
import createShipmentGetters from './CreateShipment/getters.createShipment';

import historyActions from './History/actions.history';
import historyMutations from './History/mutations.history';
import historyGetters from './History/getters.history';

import uploadDocumentActions from './UploadDocument/actions.uploadDocument';
import uploadDocumentMutations from './UploadDocument/mutations.uploadDocument';
import uploadDocumentGetters from './UploadDocument/getters.uploadDocument';

import coreActions from './actions';
import coreGetters from './getters';
import coreMutations from './mutations';

import createShipment from './CreateShipment/index.createShipment';
import uploadDocument from './UploadDocument/index.uploadDocument';
import history from './History/index.history';

Vue.use(Vuex);

// Vuex structure based on https://codeburst.io/vuex-and-typescript-3427ba78cfa8

const store = new Vuex.Store({
    // strict: process.env.NODE_ENV !== 'production',
    modules: {
        core: {
            namespaced: true,
            state: {
                userData: {
                    companyId: 0,
                    userId: 0,
                    auth0UserId: '',
                    initials: '',
                    department: ''
                },
                initialized: false,
                userLoaded: false,
                version: '1.0.0', // a simple property
                loading: true,
                companyAccountId: 0,
                companyAccounts: [],
                shipmentId: undefined,
                linkId: undefined,
                visibleBranches: [],
                shipmentSystems: [],
                news: [],
                transportProducts: [],
                countries: [],
                currencies: [],
                stateCodes: [],
                incoterms: [],
                exportReasons: [],
                companies: [],
                shipmentSystem: undefined,
                customerTransactionId: '',
                customsFreeZones: [],
                userBranch: [],
                headerData: {
                    menuItems: [],
                    appSwitcherItems: []
                }
            },
            actions: coreActions,
            mutations: coreMutations,
            getters: coreGetters
        },

        createShipment: {
            namespaced: true,
            state: createShipment,

            actions: createShipmentActions,
            mutations: createShipmentMutations,
            getters: createShipmentGetters
        },

        uploadDocument: {
            namespaced: true,
            state: uploadDocument,
            actions: uploadDocumentActions,
            mutations: uploadDocumentMutations,
            getters: uploadDocumentGetters
        },

        history: {
            namespaced: true,
            state: history,
            actions: historyActions,
            mutations: historyMutations,
            getters: historyGetters
        }
    }
});

export default store;
